// src/lib/getFileIcon.js
import {
  FileText,
  FileSpreadsheet,
  FileArchive,
  FileImage,
  FileVideo,
  FileAudio,
  File,
} from "lucide-react";

const getFileIcon = (ext) => {
  const size = 36;

  const wrapperStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: 48,
    height: 48,
    borderRadius: 8,
    backgroundColor: "#f5f5f5",
    flexShrink: 0,
  };

  const labelStyle = {
    fontSize: 10,
    fontWeight: "bold",
    marginTop: 2,
    color: "#444",
  };

  switch (ext) {
    case "pdf":
      return (
        <div style={wrapperStyle}>
          <FileText size={size} color="#d32f2f" />
          <span style={labelStyle}>PDF</span>
        </div>
      );
    case "doc":
    case "docx":
      return (
        <div style={wrapperStyle}>
          <FileText size={size} color="#1976d2" />
          <span style={labelStyle}>DOCX</span>
        </div>
      );
    case "xls":
    case "xlsx":
      return (
        <div style={wrapperStyle}>
          <FileSpreadsheet size={size} color="#388e3c" />
          <span style={labelStyle}>XLSX</span>
        </div>
      );
    case "ppt":
    case "pptx":
      return (
        <div style={wrapperStyle}>
          <FileText size={size} color="#f57c00" />
          <span style={labelStyle}>PPT</span>
        </div>
      );
    case "jpg":
    case "jpeg":
    case "png":
    case "gif":
      return (
        <div style={wrapperStyle}>
          <FileImage size={size} color="#0288d1" />
          <span style={labelStyle}>IMG</span>
        </div>
      );
    case "mp4":
    case "mkv":
      return (
        <div style={wrapperStyle}>
          <FileVideo size={size} color="#c2185b" />
          <span style={labelStyle}>VIDEO</span>
        </div>
      );
    case "mp3":
      return (
        <div style={wrapperStyle}>
          <FileAudio size={size} color="#8e24aa" />
          <span style={labelStyle}>MP3</span>
        </div>
      );
    case "zip":
    case "rar":
      return (
        <div style={wrapperStyle}>
          <FileArchive size={size} color="#ff8f00" />
          <span style={labelStyle}>ZIP</span>
        </div>
      );
    default:
      return (
        <div style={wrapperStyle}>
          <File size={size} color="#757575" />
          <span style={labelStyle}>FILE</span>
        </div>
      );
  }
};

export default getFileIcon;
